import { ChangeDetectionStrategy, Component, effect, input, model } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { debounceTime } from 'rxjs'
import { IconUi } from '../icons/icon-ui'
import { Clicks } from '@shared/directives'

@Component({
  selector: 'search-input',
  imports: [ReactiveFormsModule, IconUi, Clicks],
  templateUrl: './search-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInput {
  placeholder = input<string>('Buscar...')
  searchTerm = model<string>('')

  searchControl = new FormControl('')

  constructor() {
    this.searchControl.valueChanges.pipe(debounceTime(500), takeUntilDestroyed()).subscribe(value => {
      if (value !== null) this.searchTerm.set(value.trim())
    })

    effect(() => {
      const term = this.searchTerm()
      this.searchControl.setValue(term, { emitEvent: false })
    })
  }
}
